// @flow

import fetch from 'isomorphic-fetch';
import get from 'lodash.get';

import type { SocialNetworkName } from '../types';

const query = `
    {
        viewer {
            socialNetworks {
                name
                parameters {
                    clientId
                }
            }
        }
    }
`;

function getSocialNetworks() {
    return fetch('/soa/graphql/', {
        json: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            console.warn(`Can't get response of socialNetworks.`);
            return null;
        })
        .then(response => {
            return get(response, 'data.viewer.socialNetworks') || [];
        });
}

const getSocialNetwork = (function() {
    let socialNetworkPromise;

    return {
        byName: function(networkName: SocialNetworkName) {
            if (!socialNetworkPromise) {
                socialNetworkPromise = getSocialNetworks();
            }
            return socialNetworkPromise.then(socialNetworks =>
                socialNetworks.find(({ name }) => name === networkName)
            );
        },
    };
})();

export { getSocialNetwork };
